// Custom Kit photo step (snippets/custom-kit-upload.liquid). Shoppers choose photos, see them with the running
// price, then add: each photo is uploaded to Cloudinary and added as its own line of the selected variant with a
// `Poster N` property. Those names are read by the cart drawer and by fulfilment, so they must not change.
(function () {
  const CLOUDINARY_CLOUD = 'dopscimh9';
  const CLOUDINARY_PRESET = 'custom_kit_unsigned';
  const MAX_MB = 10;
  const MAX_PHOTOS = 60;
  const UPLOAD_CONCURRENCY = 3;
  const TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];

  const form = document.getElementById('custom-kit-form');
  if (!form) return;

  const input = form.querySelector('#ck-files');
  const variantInput = form.querySelector('#ck-variant-id');
  const grid = form.querySelector('[data-ck-grid]');
  const summary = form.querySelector('[data-ck-summary]');
  const goal = form.querySelector('[data-ck-goal]');
  const errorBox = form.querySelector('[data-ck-error]');
  const chooseLabel = form.querySelector('[data-ck-choose-label]');
  const addButton = form.querySelector('#ck-submit');
  const addLabel = form.querySelector('[data-ck-add-label]');
  const minimum = parseInt(form.dataset.cartMinimum, 10) || 0;

  let photos = []; // { file, url }
  let priceCents = parseInt(form.dataset.variantPrice, 10) || 0;
  let available = form.dataset.variantAvailable === 'true';
  let cartCents = 0;
  let busy = false;

  const rupees = (cents) => '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  const extension = (file) => (file.name.split('.').pop() || '').toLowerCase();
  const isHeic = (file) => /hei[cf]/.test(file.type) || ['heic', 'heif'].includes(extension(file));

  function showError(message) {
    errorBox.textContent = message;
    errorBox.hidden = !message;
  }

  function render() {
    grid.replaceChildren(
      ...photos.map((photo, index) => {
        const item = document.createElement('li');
        item.className = 'custom-kit__thumb';
        if (photo.url) {
          const img = document.createElement('img');
          img.src = photo.url;
          img.alt = '';
          img.onerror = () => img.replaceWith(Object.assign(document.createElement('span'), { textContent: photo.file.name }));
          item.append(img);
        } else {
          item.append(Object.assign(document.createElement('span'), { textContent: photo.file.name }));
        }
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'custom-kit__remove';
        remove.setAttribute('aria-label', `Remove photo ${index + 1}`);
        remove.textContent = '×';
        remove.disabled = busy;
        remove.addEventListener('click', () => removePhoto(index));
        item.append(remove);
        return item;
      })
    );
    grid.hidden = photos.length === 0;

    const count = photos.length;
    const total = count * priceCents;
    chooseLabel.textContent = count ? 'Add more photos' : 'Choose photos';
    summary.textContent = count ? `${count} ${count === 1 ? 'photo' : 'photos'} × ${rupees(priceCents)} = ${rupees(total)}` : '';

    const shortBy = minimum - (cartCents + total);
    if (!count) goal.textContent = '';
    else if (shortBy > 0) goal.textContent = `Add ${rupees(shortBy)} more to reach the ${rupees(minimum)} minimum order.`;
    else goal.textContent = `Your cart clears the ${rupees(minimum)} minimum order.`;

    addButton.disabled = busy || !count || !available;
    if (!busy) addLabel.textContent = count ? `Add ${count} ${count === 1 ? 'photo' : 'photos'} to cart` : 'Add to cart';
  }

  function removePhoto(index) {
    const [photo] = photos.splice(index, 1);
    if (photo?.url) URL.revokeObjectURL(photo.url);
    render();
  }

  input.addEventListener('change', () => {
    showError('');
    const rejected = [];
    for (const file of Array.from(input.files || [])) {
      if (photos.length >= MAX_PHOTOS) {
        rejected.push(`Up to ${MAX_PHOTOS} photos at a time.`);
        break;
      }
      if (!TYPES.includes(file.type) && !isHeic(file)) {
        rejected.push(`"${file.name}" isn't a JPG, PNG, WEBP or iPhone photo.`);
        continue;
      }
      if (file.size > MAX_MB * 1024 * 1024) {
        rejected.push(`"${file.name}" is over ${MAX_MB} MB. Try a smaller copy.`);
        continue;
      }
      photos.push({ file, url: URL.createObjectURL(file) });
    }
    // Clear the input so choosing the same file again still fires change; photos live in the array.
    input.value = '';
    showError(rejected.join(' '));
    render();
  });

  async function upload(file) {
    const body = new FormData();
    body.append('file', file);
    body.append('upload_preset', CLOUDINARY_PRESET);
    const response = await fetch(`https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD}/image/upload`, { method: 'POST', body });
    const json = await response.json().catch(() => ({}));
    if (!response.ok || !json.secure_url) throw new Error(`Upload failed for ${file.name}`);
    let url = json.secure_url.replace('/upload/', '/upload/fl_attachment/');
    // iPhone photos are stored as HEIC; ask Cloudinary for a JPG so the cart preview and the print file open anywhere.
    if (isHeic(file)) url = url.replace(/\.(heic|heif)$/i, '.jpg');
    return url;
  }

  async function uploadAll(onProgress) {
    const urls = new Array(photos.length);
    let next = 0;
    let done = 0;
    const worker = async () => {
      while (next < photos.length) {
        const index = next++;
        urls[index] = await upload(photos[index].file);
        onProgress(++done);
      }
    };
    await Promise.all(Array.from({ length: Math.min(UPLOAD_CONCURRENCY, photos.length) }, worker));
    return urls;
  }

  async function refreshCartBubble() {
    const sections = await fetch(`${window.routes?.root_url || '/'}?sections=cart-icon-bubble`).then((r) => r.json());
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const inner = html.querySelector('.shopify-section');
      bubble.innerHTML = inner ? inner.innerHTML : sections['cart-icon-bubble'];
    }
  }

  async function loadCartTotal() {
    try {
      const cart = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
      cartCents = cart.total_price || 0;
    } catch (error) {
      cartCents = 0;
    }
  }

  async function addToCart() {
    if (busy || !photos.length) return;
    const variantId = variantInput.value;
    if (!variantId || !available) {
      showError('This size is not available right now. Pick another size.');
      return;
    }

    busy = true;
    showError('');
    render();
    const count = photos.length;
    addLabel.textContent = `Uploading 0 of ${count}…`;

    try {
      const urls = await uploadAll((done) => busy && (addLabel.textContent = `Uploading ${done} of ${count}…`));
      addLabel.textContent = 'Adding to cart…';
      const items = urls.map((url, i) => ({ id: Number(variantId), quantity: 1, properties: { [`Poster ${i + 1}`]: url } }));
      const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error('Add to cart failed');

      photos.forEach((photo) => photo.url && URL.revokeObjectURL(photo.url));
      photos = [];
      await Promise.all([loadCartTotal(), refreshCartBubble().catch(() => {})]);
      window.ArtTheoryAnalytics?.pushEvent?.('custom_upload_completed', { form_id: 'custom-kit-form', file_count: count });
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-kit' });
      busy = false;
      render();
      summary.textContent = `${count} ${count === 1 ? 'photo' : 'photos'} added to your cart.`;
    } catch (error) {
      console.error(error);
      busy = false;
      render();
      showError("Some photos didn't upload. Check your connection and tap Add again; nothing was added to your cart.");
    }
  }

  addButton.addEventListener('click', addToCart);

  // The sticky bar is a plain product form; on this page it would add a print with no photo. Send it here instead.
  document.addEventListener(
    'submit',
    (event) => {
      // getAttribute: the form has an input named "id", which shadows form.id.
      if (event.target.getAttribute?.('id') !== 'sticky-add-to-cart-form') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (photos.length && !busy) {
        addToCart();
        return;
      }
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (!photos.length) setTimeout(() => form.querySelector('#ck-choose')?.focus({ preventScroll: true }), 400);
    },
    true
  );

  // Keep the variant and price in step with the size and finish picker (product-info.js only updates product forms).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data?.sectionId !== form.dataset.sectionId) return;
      const variant = data.variant;
      variantInput.value = variant?.id || '';
      priceCents = variant?.price ?? priceCents;
      available = Boolean(variant?.available);
      render();
    });
  }

  // Focusable label so keyboard users can open the picker; Enter/Space on a label does nothing by default.
  const choose = form.querySelector('#ck-choose');
  choose.tabIndex = 0;
  choose.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      input.click();
    }
  });

  loadCartTotal().then(render);
  render();
})();
